import React from 'react';
import {Box} from '@chakra-ui/react';
import {searchTextMatchRanges} from '../../utils/searchText';

export function plannerSearchHighlightNode(text: unknown, query: unknown) {
  const value = String(text ?? '');
  const ranges = searchTextMatchRanges(value, query);
  if (!value || !ranges.length) return null;

  const nodes: React.ReactNode[] = [];
  let cursor = 0;

  ranges.forEach((range, index) => {
    if (range.start > cursor) {
      nodes.push(value.slice(cursor, range.start));
    }
    nodes.push(
      <Box
        as="mark"
        key={`${range.start}-${range.end}-${index}`}
        data-planner-search-highlight="true"
        bg="rgba(253, 224, 71, 0.45)"
        borderRadius="2px"
        color="inherit"
        display="inline"
        lineHeight="inherit"
        m={0}
        p={0}
        verticalAlign="baseline"
        sx={{
          WebkitBoxDecorationBreak: 'clone',
          boxDecorationBreak: 'clone',
        }}
      >
        {value.slice(range.start, range.end)}
      </Box>,
    );
    cursor = range.end;
  });

  if (cursor < value.length) {
    nodes.push(value.slice(cursor));
  }

  return <>{nodes}</>;
}
